import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import moment from 'moment';
import 'moment/locale/pt-br'
import api from "../../services/api.js";
import Logo from "../../assets/cl_logo.png"
import "../aniversario-franquias/aniversario-franquias.css";
import { dadosLogin } from "../../zustand/zuztand.js"


function AniversarioFranquias() {

  const navigate = useNavigate();
  const { ifLogado, usuario, nivel_user } = dadosLogin()

  const local = moment().locale('pt-br').format('LL'); //converte a data par pt-br
  const local_novo = local.slice(5); // separa o texto inicial ex 12 se setembro de 2024 ficando somente setembro...
  const [dados, setDados] = useState([]);

  const mesAtuals = (local.split(" ")[2]); // converte 12 de setembro de 2024  em array e pega o indice 2 (mes extenço)

  const [cadastros, setCadastros] = useState([]);
  const [larguraTela, setLarguraTela] = useState(window.innerWidth);
  const ehMobile = larguraTela < 1100;

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setLarguraTela(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  useEffect(() => {

    var mes = new Date();
    var month = mes.getMonth();
    var mesAtual = month + 1;
    let novo_array = [];

    api.get("/franquia_aniver_listar")
      .then((resp) => {
        // console.log(resp.data)
        resp.data.map((item) => {
          let dtaAniver = parseInt(item.data_inalg.substring(3, 5));

          if (dtaAniver === mesAtual) {
            novo_array.push({
              nome: item.razao_franquia,
              apelido: item.nome_franquia,
              data: item.data_inalg,
              cid: item.cidade_franquia,
              img: item.img_franquia,
              uf: item.uf_franquia
            })
          }
        })
        //console.log(novo_array)
        setDados(novo_array);
      })
      .catch((err) => {
        setDados([]);
        alert("Erro ao carregar dados");
      });

  }, []);

    useEffect(() => {

    var mes = new Date();
    var month = mes.getMonth();
    var mesAtual = month + 1;
    let novo_array = [];

    api.get("/franquia_aniver_listar")
      .then((resp) => {
        //console.log(resp.data)
        resp.data.map((item) => {
          let dtaAniver = parseInt(item.data_inalg.substring(3, 5));

          if (dtaAniver === mesAtual) {
            novo_array.push({
              id: item.id_franquia,
              empresa: item.razao_franquia,           
              apelido: item.nome_franquia,
              data: item.data_inalg,
              localizacao: item.cidade_franquia,
              logo: item.img_franquia,
              uf: item.uf_franquia
            })
          }
        })
       // console.log(novo_array)
        setCadastros(novo_array);
      })
      .catch((err) => {
        setCadastros([]);
        alert("Erro ao carregar dados");
      });

  }, []);

  function CadastroCard({ empresa, apelido, localizacao, data, logo, uf }) {
    return <>
      <div className="card h-100 shadow-sm  ">
        <div className="card-body d-flex flex-column align-items-center p-3">
          <div className="logo-container mb-3">
            <img src={logo || "/api/placeholder/150/150"} alt={`Logo de ${empresa}`} className="img-fluid rounded-circle" />
          </div>
          <h6 className="card-title text-center fw-bold">{empresa}</h6>
          <div className="card-text text-center">
            <p className="mb-1 text-muted">
              <i className="bi bi-geo-alt me-1"></i>
              {apelido}- {uf}
            </p>
            <p className="text-muted small">
              <i className="bi bi-calendar me-1"></i>
              {data}
            </p>
          </div>
        </div>
      </div>
    </>

  };

  return <>

    {ehMobile ?
      <>
        <div className="row d-flex mt-2 ms-2 me-2">
          <div className="d-flex justify-content-between ">
            <h4 className="text-white ">Aniversários Franquias: {mesAtuals}</h4>
            <Link to="/menu-aniversariantes" className="btn btn-success btn-sm me-2 " >Voltar </Link>
          </div>
        </div>
        <div className="tela-card-fran">
          <div className="container py-4 ">
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3 ">
              {cadastros.map((item) => (
                <div className="col  " key={item.id}>
                  <CadastroCard
                    empresa={item.empresa}
                    localizacao={item.localizacao}
                    apelido={item.apelido}
                    data={item.data}
                    logo={item.logo}
                    uf={item.uf}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
      :
      <>
        <div className="d-flex container-fundo-franquias">
          <div className="d-block container-body-franquias">
            {
              ifLogado !== "notLogad" ? <>

                <div className="d-flex justify-content-between">
                  <div className="col-1">
                  </div>
                  <h4 className="ms-3 mt-2">
                    Aniversários Franquias: {local_novo}
                  </h4>
                  <div className="col-1 ">
                    <Link to="/menu-aniversariantes" className="btn btn-success p-2 me-5 mt-2 btn-sm" >Voltar </Link>
                  </div>
                </div>
                {
                  dados.length <= 3 ?
                    <div className="d-flex flex-row p-2 div-cards-center">
                      {
                        dados.map((item) => {
                          return <div key={item.id_franquia} className="d-flex">

                            <div className="col-10">
                              {item.img ?
                                <img src={item.img} className="img-card-franquias ms-3" alt="..." /> :
                                <img src={Logo} className="img-card-franquias ms-3" alt="..." />
                              }
                              <div className="ms-3 mt-2 d-flex">
                                <small className="text-dark">{item.nome}</small>
                              </div>
                              <div className="ms-3 mt-2 d-flex">
                                <small className="text-dark">{item.apelido} - {item.uf}</small>
                              </div>

                              <div className="ms-3  d-flex">
                                <p className="text-secondary">{item.data}</p>
                              </div>
                            </div>
                          </div>
                        })
                      }
                    </div>

                    : <div className="d-flex flex-row p-2 div-cards-start">
                      {
                        dados.map((item) => {
                          return <div key={item.id_franquia} className="d-flex">

                            <div className="col-10">
                              {item.img ?
                                <img src={item.img} className="img-card-franquias ms-3" alt="..." /> :
                                <img src={Logo} className="img-card-franquias ms-3" alt="..." />

                              }
                              <div className="col-12 ms-3 mt-2 d-flex">
                                <p className="text-dark">{item.nome}</p>
                              </div>
                              <div className="ms-3 d-flex">
                                <p className="text-secondary">{item.cid} - {item.uf}</p>
                              </div>
                              <div className="ms-3 d-flex">
                                <p className="text-secondary">{item.data}</p>
                              </div>
                            </div>
                          </div>
                        })
                      }
                    </div>
                }
              </> : navigate('/login')
            }
          </div>
        </div>
      </>
    }
  </>
}
export default AniversarioFranquias;